<template>
    <button :class="classes" type="button" data-toggle="collapse"
            data-target="#navbarSupportedContent1" aria-controls="navbarSupportedContent"
            aria-expanded="false" aria-label="Toggle navigation"
            @click="onToggle()">
        <span class="navbar-toggler-line"></span>
        <span class="navbar-toggler-line"></span>
        <span class="navbar-toggler-line"></span>
    </button>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        computed: {
            classes() {
                return [
                    'navbar-toggler',
                    {'collapsed': !this.menuOpened},
                ]
            },
            ...mapState({
                menuOpened: state => state.ui.menuOpened
            })
        },
        methods: {
            onToggle() {
                this.$store.commit('ui/toggleMenu')
                this.$store.dispatch('ui/toggleHeartbeat')
            }
        }
    }
</script>
